import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import SimpleReactValidator from 'simple-react-validator';

import { postPrice, returnSection } from '../../../store/actions/order';
import { errorMessage } from '../../../utils/message';
import { canTypeForNumInput, seperateNumber, seprate, seprateOne } from '../../../utils/numbers';
import { isPersianWithNumber } from '../../../utils/persianLatter';
import { toEnglishNumbers } from '../../../utils/datePicker';

const PayInfo = () => {
   const { executeRecaptcha } = useGoogleReCaptcha();
   const dispatch = useDispatch();
   const {
      section,
      assurance,
      serviceFee,
      packSizePacking,
      packing,
      paymentTime,
      serviceType,
      deliveryType,
      destination,
      packages,
      deliveryTypeId,
      origin,
      serviceTypeId,
   } = useSelector((state) => state.order);

   const [, forceUpdate] = useState();
   const [pickup, setPickup] = useState(true);
   const [registerOrder, setRegisterOrder] = useState({
      assu: assurance,
      service: serviceFee,
      size: packSizePacking,
      packes: packing,
      time: paymentTime,
   });
   const [type, setType] = useState('');
   const [typeName, setTypeName] = useState('');
   const [count, setCount] = useState('');

   const validator = useRef(
      new SimpleReactValidator({
         messages: {
            required: 'پر کردن این فیلد الزامی میباشد',
            min: 'کمتر از 2 حرف نمی تواند باشد',
         },
         validators: {
            descValid: {
               message: 'توضیحات معتبر نیستند',
               rule: (val) => {
                  const add = isPersianWithNumber(val);
                  return add;
               },
               required: true,
            },
         },
         element: (message) => <div style={{ color: 'red', fontSize: '1.3rem' }}>{message}</div>,
      })
   );

   const handleChange = (e) => {
      setRegisterOrder({
         ...registerOrder,
         [e.target.name]: e.target.value,
      });
      validator.current.showMessageFor(e.target.name);
   };
   const handleInsurance = (e, state) => {
      setRegisterOrder({
         ...registerOrder,
         assu: { ...registerOrder.assu, stat: state, value: e.target.value },
      });
   };
   const handleService = (e, stat, price) => {
      // if (price) {
      //    setRegisterOrder({
      //       ...registerOrder,
      //       service: {
      //          ...registerOrder.service,
      //          stat,
      //          value: e.target.value,
      //       },
      //    });
      // } else if (!price) {
      //    setRegisterOrder({
      //       ...registerOrder,
      //       service: {
      //          ...registerOrder.service,
      //          stat,
      //          desc: e.target.value,
      //       },
      //    });
      //    validator.current.showMessageFor(e.target.name);
      // } else {
      //    setRegisterOrder({
      //       ...registerOrder,
      //       service: {
      //          ...registerOrder.service,
      //          stat,
      //       },
      //    });
      // }
   };
   const handleOnChangePacking = (e) => {
      setType(Number(e.target.value));
      const { title } = packSizePacking.filter((item) => item.id === Number(e.target.value))[0];
      setTypeName(title);
   };
   const handlePacking = () => {
      if (!type && !count) {
         errorMessage('مقادیر خواسته شده در اقلام را پر کنید');
         return;
      } else {
         if (type) {
            const found = registerOrder.packes.findIndex((item) => item.type === type);
            if (found === -1) {
               setRegisterOrder((currentRegister) => {
                  return {
                     ...currentRegister,
                     packes: [
                        ...registerOrder.packes,
                        {
                           count,
                           type,
                           typeName,
                        },
                     ],
                  };
               });
               setCount('');
               setType('');
            } else {
               const arrayPackagesUpdate = [...registerOrder.packes];
               for (let j = 0; j < arrayPackagesUpdate.length; j++) {
                  if (j === found) {
                     arrayPackagesUpdate[found].count = +arrayPackagesUpdate[found].count + +count;
                  }
                  setRegisterOrder({ ...registerOrder, packes: arrayPackagesUpdate });
               }
            }
         }
      }
   };
   const handleDeletePacking = (i) => {
      const allPacking = [...registerOrder.packes];
      const filter = allPacking.filter((item, index) => index !== i);
      setRegisterOrder({ ...registerOrder, packes: filter });
   };
   const handleNext = async () => {
      if (validator.current.allValid()) {
         if (registerOrder.assu.stat && registerOrder.assu.value === '') {
            return errorMessage('ارزش کالا را وارد کنید');
         } else if (registerOrder.service.stat && registerOrder.service.value === '') {
            return errorMessage('هزینه خدمات را وارد کنید');
         }
         const token = await handleReCaptchaVerify();

         await dispatch(
            postPrice(
               serviceType,
               deliveryType,
               Number(destination),
               packages,
               registerOrder.packes,
               {
                  stat: registerOrder.assu.stat,
                  value: parseFloat((registerOrder.assu.value + '').replaceAll(',', '')),
               },
               pickup,
               origin,
               {
                  stat: registerOrder.service.stat,
                  value: parseFloat((registerOrder.service.value + '').replaceAll(',', '')),
                  desc: registerOrder.service.desc,
               },
               Number(deliveryTypeId),
               Number(serviceTypeId),
               token
            )
         );
      } else {
         validator.current.showMessages();
         forceUpdate(1);
      }
   };

   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
         return;
      }
      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);

   return (
      <div
         className={section === 4 ? 'progresstabs__content active-nav' : 'progresstabs__content'}
         style={{ minHeight: 'unset' }}
      >
         <div className='progresstabs__content-info'>
            <h1 className='progresstabs__content-title'>اطلاعات پرداخت</h1>
            <div className='progresstabs__content-service'>
               <div className='progresstabs__content-service-value'>
                  <label className='progresstabs__content-service-lable'>
                     <input
                        type='checkbox'
                        className='progresstabs__content-service-input'
                        name='pickup'
                        defaultChecked
                        value={pickup}
                        onChange={() => setPickup(!pickup)}
                     />
                     ارسال با پیک
                  </label>
               </div>
            </div>
            <div className='progresstabs__content-payment'>
               <h4 className='progresstabs__content-payment-title'>نوع پرداخت را تعیین کنید</h4>
               <div className='progresstabs__content-payment-radio'>
                  <label className='progresstabs__content-payment-lable'>
                     <input
                        type='radio'
                        className='progresstabs__content-payment-input'
                        name='time'
                        defaultChecked
                        value={'1'}
                        onChange={handleChange}
                     />
                     کرایه در مبدا (پیشکرایه)
                  </label>
                  <label className='progresstabs__content-payment-lable'>
                     <input
                        type='radio'
                        className='progresstabs__content-payment-input'
                        name='time'
                        value={'2'}
                        onChange={handleChange}
                     />
                     کرایه در مقصد (پسکرایه)
                  </label>
               </div>
            </div>
            <div className='progresstabs__content-insurance'>
               <h4 className='progresstabs__content-insurance-title'>
                  تمایلی به بیمه کردن کالا دارید؟
               </h4>
               <div className='progresstabs__content-insurance-value'>
                  <label className='progresstabs__content-insurance-lable'>
                     <input
                        type='radio'
                        name='inssurance'
                        className='progresstabs__content-insurance-input'
                        defaultChecked
                        value={''}
                        onChange={(e) => handleInsurance(e, false)}
                     />
                     خیر
                  </label>
                  <label className='progresstabs__content-insurance-lable'>
                     <input
                        type='radio'
                        name='inssurance'
                        className='progresstabs__content-insurance-input'
                        value={''}
                        onChange={(e) => handleInsurance(e, true)}
                     />
                     بله
                  </label>

                  <div
                     className={
                        registerOrder.assu.stat
                           ? 'progresstabs__content-insurance-price'
                           : 'progresstabs__content-insurance-price input-opacity'
                     }
                  >
                     <p>ارزش کالا</p>
                     <input
                        type='text'
                        name='assuValue'
                        onChange={(e) => handleInsurance(e, true)}
                        readOnly={registerOrder.assu.stat ? false : true}
                        value={
                           registerOrder.assu.value
                              ? seperateNumber(registerOrder.assu.value + '')
                              : ''
                        }
                        onKeyDown={(e) => {
                           canTypeForNumInput(e);
                           seprateOne(e);
                        }}
                        onKeyUp={seprate}
                     />
                     <p>تومان</p>
                  </div>
               </div>
            </div>

            <div className='progresstabs__content-service'>
               <h4 className='progresstabs__content-service-title'>
                  هزینه خدمات به هزینه ارسال افزوده شود؟
               </h4>
               <div className='progresstabs__content-service-value'>
                  <label className='progresstabs__content-service-lable'>
                     <input
                        type='radio'
                        name='service'
                        className='progresstabs__content-service-input'
                        onChange={(e) => {
                           setRegisterOrder((prev) => ({
                              ...prev,
                              service: {
                                 ...prev.service,
                                 stat: false,
                              },
                           }));
                        }}
                        checked={!registerOrder.service.stat}
                     />
                     خیر
                  </label>
                  <label className='progresstabs__content-service-lable'>
                     <input
                        type='radio'
                        name='service'
                        className='progresstabs__content-service-input'
                        onChange={(e) => {
                           setRegisterOrder((prev) => ({
                              ...prev,
                              service: {
                                 ...prev.service,
                                 stat: true,
                              },
                           }));
                        }}
                        checked={registerOrder.service.stat}
                     />
                     بله
                  </label>

                  <div
                     className={
                        registerOrder.service.stat
                           ? 'progresstabs__content-service-price'
                           : 'progresstabs__content-service-price input-opacity'
                     }
                  >
                     <p>هزینه خدمات</p>
                     <input
                        name='value'
                        type='text'
                        onChange={(e) => {
                           setRegisterOrder((prev) => ({
                              ...prev,
                              service: {
                                 ...prev.service,
                                 value: seperateNumber(e.target.value + ''),
                              },
                           }));
                        }}
                        readOnly={registerOrder.service.stat ? false : true}
                        value={
                           registerOrder.service.value
                              ? seperateNumber(registerOrder.service.value + '')
                              : ''
                        }
                        onKeyDown={(e) => {
                           canTypeForNumInput(e);
                           seprateOne(e);
                        }}
                        onKeyUp={seprate}
                     />
                     <p>تومان</p>
                  </div>
               </div>
            </div>

            <div
               className={
                  registerOrder.service.stat
                     ? 'progresstabs__content-description'
                     : 'progresstabs__content-description input-opacity'
               }
            >
               <label className='progresstabs__content-description-label '>
                  <h4 className='progresstabs__content-description-title'>توضیحات</h4>
                  <textarea
                     rows='10'
                     name={'desc'}
                     readOnly={registerOrder.service.stat ? false : true}
                     value={registerOrder.service.desc || ''}
                     // onChange={(e) => handleService(e, true, false)}
                     onChange={(e) => {
                        setRegisterOrder((prev) => ({
                           ...prev,
                           service: {
                              ...prev.service,
                              desc: e.target.value,
                           },
                        }));
                     }}
                  />
                  {registerOrder.service.stat &&
                     validator.current.message(
                        'desc',
                        registerOrder.service.desc,
                        `${registerOrder.service.stat ? 'required|min:2' : ''}`
                     )}
               </label>
            </div>
         </div>
         <div className='progresstabs__content-calc'>
            <div className='progresstabs__content-calc-packet'>
               <h4 className='progresstabs__content-calc-title'>
                  درصورت نیاز اقلام بسته بندی خود را ثبت کنید
               </h4>
               <label className='progresstabs__content-calc-label'>
                  نوع
                  <select
                     id='type-select'
                     className='progresstabs__content-selector'
                     name='type'
                     value={type}
                     onChange={handleOnChangePacking}
                  >
                     <option hidden>نوع و ابعاد مورد نظر</option>
                     {packSizePacking?.map((item) => (
                        <option key={item.id} value={item.id}>
                           {item.title}
                        </option>
                     ))}
                  </select>
               </label>
               <label className='progresstabs__content-calc-label'>
                  تعداد
                  <input
                     type='text'
                     className='progresstabs__content-calc-input'
                     name='count'
                     value={count}
                     onChange={(e) => setCount(toEnglishNumbers(e.target.value))}
                     onKeyDown={(e) => canTypeForNumInput(e)}
                  />
               </label>

               <button className='progresstabs__content-calc-btn' onClick={handlePacking}>
                  افزودن
               </button>
            </div>
            {registerOrder.packes.length !== 0 && (
               <div className='progresstabs__content-calc-number'>
                  <h4 className='progresstabs__content-calc-title'>اقلام افزوده شده</h4>
                  <div className='progresstabs__content-calc-boxes'>
                     {registerOrder.packes.map((item, index) => {
                        return (
                           <div key={index} className='progresstabs__content-calc-item'>
                              <p>{item.typeName}</p>
                              <p>{item.count} عدد</p>
                              <img
                                 src='./img/delete.png'
                                 alt=''
                                 onClick={() => handleDeletePacking(index)}
                              />
                           </div>
                        );
                     })}
                  </div>
               </div>
            )}
         </div>
         <div className='progresstabs__content-buttons'>
            <button
               className='btn btn--secondary return-btn'
               onClick={() => dispatch(returnSection())}
            >
               بازگشت
            </button>
            <button className='btn btn--secondary next-btn' onClick={handleNext}>
               تایید و ادامه
            </button>
         </div>
      </div>
   );
};

export default PayInfo;
